// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQueryWithOffset } from '@hooks/other/useQueryWithOffset';
import { UseQueryResult } from '@tanstack/react-query';
import { UserService } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Service/User';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorParty } from '../../utility-operator/useOperatorParty';

const useUserServices: () => UseQueryResult<TemplateContract<UserService>[], string> = () => {
  const ledgerApi = useLedgerApiClient();
  const operator = useOperatorParty()?.data;

  return useQueryWithOffset({
    queryKey: ['queryCollateralUserServices', operator],
    enabled: !!operator,
    queryFn: async (_, offset) => {
      if (!offset || !operator) {
        return Promise.resolve([]);
      }
      return ledgerApi.queryCollateralUserServices(offset, operator);
    },
  });
};

export default useUserServices;
